module.exports = __webpack_public_path__ + "static/media/muzik-gema.dc565502.png";